<template>
  <div>
    <el-row>
      <el-col>
        <el-button size="medium" type="primary" plain @click="exportData" style="margin-top: 20px">导出手动入库记录</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableDataPage" stripe border style="width: 100%;margin-top:20px" @selection-change="handleSelectionChange">
          <!-- <el-table-column type="selection" width="50"></el-table-column> -->
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <!-- <el-table-column prop="AFTER_NAME" label="产品名称" min-width="80"></el-table-column> -->
          <el-table-column prop="DATE" label="入库时间" width="120"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="商品" min-width="80"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="商品编码" min-width="80"></el-table-column>
          <el-table-column prop="BATCH" label="批次" min-width="80"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="入库数量" width="100"></el-table-column>
          <el-table-column prop="PRODUCT_PRICE" label="单价" width="100"></el-table-column>
          <!-- <el-table-column prop="REAL_WORTH" label="实际入库价格" min-width="80"></el-table-column> -->
          <el-table-column prop="PRODUCTION_DATE" label="生产日期" width="120"></el-table-column>
          <el-table-column prop="COMMENTS" label="备注" min-width="100"></el-table-column>
          <!-- <el-table-column prop="REAL_WORTH" label="实际入库价格" min-width="80"></el-table-column> -->
          <!-- <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="returnWarehouse(scope.row)">退货</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </el-col>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handlePageChange" :current-page.sync="currentPage" :page-size="15" layout="total,prev, pager, next, jumper"
          :total="total_count">
        </el-pagination>
      </el-col>
    </el-row>
    <el-dialog title="退货信息" center :visible.sync="returnVisible" width="800px">
      <el-table :data="returnList" border>
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="AFTER_NAME" label="产品名称" min-width="100"></el-table-column>
        <el-table-column prop="AFTER_TYPE_UNIT" label="单位" width="80"></el-table-column>
        <el-table-column prop="AFTER_COUNT" label="入库数量" width="80"></el-table-column>
        <el-table-column label="退货数量">
          <template slot-scope="scope">
            <el-input v-model="scope.row.COUNT"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="退货原因">
          <template slot-scope="scope">
            <el-input v-model="scope.row.COMMENT"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="returnClose">取 消</el-button>
        <el-button size="small" @click="submitReturn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  historyReturnFun, manualInstockDetail, exportManualInstockFun,
} from '@/assets/api/warehouseManager';

export default {
  data() {
    return {
      statusFlag: 0,
      stepOr: [],
      // managername:sessionStorage.getItem("name"),
      DELIVER_CODE: sessionStorage.getItem('ORDER_CODE'),
      ORDER_ID: sessionStorage.getItem('ORDER_ID'),
      tableData: [],
      orderData: [],
      titleData: [{
        SUPPLIER_NAME: '',
        PROJECT_ADDRESS: '',
        ORDER_CODE: '',
        PROJECT_NAME: '',
        SEND_DAY: '',
        PROJECT_TELPHONE: '',
        DK_NAME: '',
      }],
      currentRow: {},
      currentCount: 0,
      snapReturnList: [],
      FormVisible: false,
      backItem: {},
      Form: {},
      PRODUCT_COUNT: '',
      DETAIL_ID: '',
      returnVisible: false,
      returnForm: {},
      formLabelWidth: '120px',
      returnList: [],
      checkedArray: [],
      total_count: 0,
      currentPage: 1,
      tableDataPage: [],
      tableDataTemp: [],
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
    };
  },
  created() {
    this.getRecordDetail();
  },
  methods: {
    // ----------------------退货
    returnWarehouse(row) {
      this.returnVisible = true;
      this.returnForm = row;
    },
    returnClose() {
      this.returnVisible = false;
    },
    submitReturn() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const submitArr = this.returnList.map((item) => ({
            BATCH: item.BATCH, PRODUCT_CODE: item.AFTER_PRODUCT_CODE, PRODUCT_COUNT: item.COUNT, RETURN_REASON: item.COMMENT ? item.COMMENT : '',
          }));
          const params = {
            ORDER_ID: Number(sessionStorage.getItem('ORDER_ID')),
            DETAILS: submitArr,
            RECORD_ID: Number(sessionStorage.getItem('DELIVER_ID')),
          };
          historyReturnFun(params).then((result) => {
            this.$message.show({ text: '移至退货仓成功', type: 'success' });
            this.getRecordDetail();
            this.returnVisible = false;
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // ----------------------拉取数据
    getRecordDetail() {
      manualInstockDetail()
        .then((result) => {
          if (result.length !== 0) {
            this.tableData = result.map((item) => Object.assign(item, { PRODUCT_CODE: item.PRODUCT_CODE.toString() }));
            this.tableDataTemp = this.tableData;
            this.loadPageChangeProducts();
            this.total_count = this.tableDataTemp.length;
          } else {
            this.tableData = [];
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 选择需要退货的商品
    handleSelectionChange(val) {
      this.checkedArray = val;
    },
    retuenWare() {
      if (this.checkedArray.length !== 0) {
        this.returnList = this.checkedArray;
        this.returnVisible = true;
      } else {
        this.$message.show({ text: '请选择产品', type: 'warning' });
      }
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.loadPageChangeProducts(page - 1);
    },
    loadPageChangeProducts(pageIndex = 0, pageSize = this.pageSize - 1) {
      const INDEX = pageIndex * (pageSize + 1);
      const END = INDEX + pageSize + 1;
      if (END > this.tableDataTemp.length) {
        this.tableDataPage = this.tableDataTemp.slice(INDEX);
      } else {
        this.tableDataPage = this.tableDataTemp.slice(INDEX, END);
      }
    },
    exportData() {
      const params = {
      };
      exportManualInstockFun(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>
<style scoped>
.footer {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
}
ul {
  list-style: none;
  min-height: 5px;
  padding: 0;
}
li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/manualInstockDetail.vue